export default "__VITE_ASSET__z4rPtt2Z__"